module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-loading-indicator"
  }, [_c('div', {
    staticClass: "pp-loading-indicator__icon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-refresh"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6a58e16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingIndicator.vue
// module id = 138
// module chunks = 0 1